import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import FleetHelper, { FleetConstants } from 'features/Fleet/fleetHelper';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import miscHelper from 'general/helpers/miscHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function EditDriverView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { driverId, agencyId, isAddCustomer = false } = props;
    const { operatorList, operatorOptions } = useAgency();
    const { user, permissionList } = useSelector((state) => state.auth);
    const adminRole = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatar, setAvatar] = useState('');
    const [type, setType] = useState(FleetConstants.FleetDriverType.PERSONAL);
    const [fullname, setFullname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [discountType, setDiscountType] = useState(FleetConstants.PricingType.STANDARD);
    const [discountRate, setDiscountRate] = useState(0);
    const [companyName, setCompanyName] = useState('');
    const [taxCode, setTaxCode] = useState('');
    const [address, setAddress] = useState('');
    const [idCardNumber, setIdCardNumber] = useState('');
    const [idCardDocuments, setIdCardDocuments] = useState([]);
    const [imageSrc, setImageSrc] = useState([null, null]);
    const [selectedAgency, setSelectedAgency] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [workingType, setWorkingType] = useState('');
    const [carNumbers, setCarNumbers] = useState('');
    const [paymentMethod, setPaymentMethod] = useState(FleetConstants.PaymentMethod.FLEET);
    const [creditLimitPeriod, setCreditLimitPeriod] = useState('');
    const [creditLimit, setCreditLimit] = useState('');
    const [driverDetail, setDriverDetail] = useState();
    const [isDriverPersonal, setDriverPersonal] = useState(true);
    const [isReady, setIsReady] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (driverId) handleGetDriverDetail(driverId);
        else setIsReady(true);
    }, [driverId]);
    useEffect(() => {
        if (driverDetail && driverDetail?.driver?.agencyId) {
            FleetHelper.API.requestGetFleetDetail(driverDetail?.driver?.agencyId).then((data) => {
                if (data && Object.keys(data)?.length > 0) {
                    setSelectedAgency({
                        id: data?.agencyId,
                        name: data?.name,
                        email: data?.email,
                        item: data,
                    })
                }
            });
        }
    }, [driverDetail]);
    useEffect(() => {
        if (!isAddCustomer && agencyId || !adminRole) {
            const id = agencyId || user?.agency?.agencyId;
            FleetHelper.API.requestGetFleetDetail(id).then((data) => {
                if (data && Object.keys(data)?.length > 0) {
                    setSelectedAgency({
                        id: data?.agencyId,
                        name: data?.name,
                        email: data?.email,
                        item: data,
                    })
                }
            });
        }
    }, [isAddCustomer, agencyId, adminRole, user]);

    useEffect(() => {
        if (driverDetail) {
            setType(driverDetail?.driver?.type);
            setAvatar(driverDetail?.avatar);
            setFullname(driverDetail?.fullname);
            setPhone(driverDetail?.phone);
            setEmail(driverDetail?.email);
            setDiscountRate(driverDetail?.discountRate * 100 ?? 0);
            setCompanyName(driverDetail?.driver?.companyName);
            setTaxCode(driverDetail?.driver?.taxCode);
            setAddress(driverDetail?.driver?.address);
            setIdCardNumber(driverDetail?.driver?.idCardNumber);
            setIdCardDocuments(driverDetail?.driver?.idCardDocuments);
            setCompanyCode(driverDetail?.driver?.companyCode);
            setWorkingType(driverDetail?.driver?.workingType);
            setCarNumbers(driverDetail?.driver?.carNumbers);
            setPaymentMethod(driverDetail?.driver?.paymentMethod);
            setCreditLimitPeriod(driverDetail?.driver?.creditLimitPeriod);
            setCreditLimit(driverDetail?.driver?.creditLimit);
        }
    }, [driverDetail]);
    useEffect(() => {
        if (!isAddCustomer) {
            setType(FleetConstants.FleetDriverType.ORGANIZATION);
            setDriverPersonal(false);
        }
    }, [isAddCustomer])
    useEffect(() => {
        if (type === FleetConstants.FleetDriverType.ORGANIZATION) setDriverPersonal(false);
        else setDriverPersonal(true);
    }, [type])
    useEffect(() => {
        if (discountRate === 0) setDiscountType('STANDARD');
        else if (discountRate === 100) setDiscountType('FREE');
        else setDiscountType('DISCOUNT');
    }, [discountRate])
    useEffect(() => {
        if (discountType === 'STANDARD') setDiscountRate(0);
        else if (discountType === 'FREE') setDiscountRate(100);
    }, [discountType])

    const dropdownAgencyEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="agencyId"
                name="agencyId"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                            ${(!!driverDetail || !isAddCustomer && agencyId || !adminRole) ? 'disabled' : ''}`}
                        type="button"
                    >
                        {selectedAgency?.name ?? 'Chọn doanh nghiệp'}
                    </button>
                }
                selectedValue={selectedAgency}
                dropdownMenuItems={[{ name: 'DNVT', role: 'FLEET' }]}
                getSubItems={async (item) => {
                    return FleetHelper.API.requestGetFleetList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.fleets?.map((row) => ({
                                id: row?.agencyId,
                                name: row?.name,
                                email: row?.email,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedAgency(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'DNVT',
                    role: 'FLEET',
                }}
                subTitleType="email"
                disabled={!!driverDetail || !isAddCustomer && agencyId || !adminRole}
            />
        );
    }, [driverDetail, selectedAgency, readyToValidate, adminRole]);

    // MARK: ---- FUNCTIONS ----
    const handleGetDriverDetail = (id) => {
        ChargeHelper.API.Driver.requestGetDriverDetail(id).then((data) => {
            if (data && Object.keys(data)?.length > 0) {
                setDriverDetail(data);
                if (data?.idCardDocuments) {
                    setImageSrc(data.idCardDocuments);
                }

                setIsReady(true);
            }
        });
    };

    const handleSetImage = (file, index) => {
        setImageSrc((prev) => {
            const updatedImageSrc = [...prev];
            updatedImageSrc[index] = file;
            return updatedImageSrc;
        });
    };

    const handleUploadFile = async (fileList) => {
        const newImagePaths = [];

        if (!fileList) {
            return newImagePaths;
        }

        if (fileList instanceof File) {
            const res = await miscHelper.callApiUploadFile(fileList);
            return res?.[0]?.relativePath || null;
        }

        if (Array.isArray(fileList)) {
            for (const image of fileList) {
                if (image instanceof File) {
                    const res = await miscHelper.callApiUploadFile(image);
                    if (res?.[0]?.relativePath) {
                        newImagePaths.push(res[0].relativePath);
                    }
                } else if (image) {
                    newImagePaths.push(image);
                }
            }
            return newImagePaths;
        }

        return fileList;
    };

    const handleSubmit = async () => {

        setReadyToValidate(true);
        if (
            !Utils.isValid(fullname) ||
            !Utils.isValid(email) ||
            !Utils.isValid(phone) ||
            !Utils.isValid(discountRate)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (type === FleetConstants.FleetDriverType.ORGANIZATION) {
            if (
                !Utils.isValid(companyCode) ||
                !Utils.isValid(workingType) ||
                !Utils.isValid(carNumbers)
            ) {
                ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
                return;
            }
            if (carNumbers < 0) {
                ToastHelper.showError('Số lượng xe phải lớn hơn hoặc bằng 0');
                return;
            }
        }

        if (!phone.match(AppConfigs.regex.phone)) {
            ToastHelper.showError('Số điện thoại không hợp lệ');
            return;
        }

        if (!email.match(AppConfigs.regex.email)) {
            ToastHelper.showError('Email không hợp lệ');
            return;
        }
        if (Utils.isValid(taxCode) &&
            !taxCode.match(AppConfigs.regex.taxCode10) && !taxCode.match(AppConfigs.regex.taxCode13)) {
            ToastHelper.showError('MST/Mã số định danh không hợp lệ');
            return;
        }
        if (Utils.isValid(idCardNumber) && !idCardNumber.match(AppConfigs.regex.idCardNumber)) {
            ToastHelper.showError('Số CCCD không hợp lệ');
            return;
        }
        if (Utils.isValid(discountRate) && discountType === 'DISCOUNT') {
            if (discountRate <= 0) {
                ToastHelper.showError('Tỷ lệ chiết khấu phải lớn hơn 0');
                return;
            }
            if (discountRate >= 100) {
                ToastHelper.showError('Tỷ lệ chiết khấu phải nhỏ hơn 100');
                return;
            }
        }
        let params = {
            type,
            fullname,
            phone,
            email,
            discountRate: discountRate / 100,
            operatorId: _.first(operatorList)?.operatorId,
            companyName,
            taxCode,
            address,
            idCardType: 'CC',
            idCardNumber,
            agencyId: selectedAgency?.id,
            companyCode,
            workingType,
            carNumbers,
            paymentMethod,
            creditLimitPeriod,
            creditLimit,
        };
        if (avatarFile) {
            params.avatar = await handleUploadFile(avatarFile);
        }
        if (imageSrc) {
            params.idCardDocuments = await handleUploadFile(imageSrc);
        }
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        console.log({ params });
        setLoading(true);
        if (!driverDetail) {
            const res = await ChargeHelper.API.Driver.requestAddDriver(params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Thêm mới khách hàng thành công');
                handleClose();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        } else {
            const res = await ChargeHelper.API.Driver.requestUpdateDriver(driverDetail?.userId, params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Chỉnh sửa thông tin khách hàng thành công');
                handleClose();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    const handleClose = () => {
        router.navigate(-1);
    };

    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: isAddCustomer ? "Danh sách khách hàng" : "Danh sách tài xế",
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    {
                        title: driverId
                            ? isAddCustomer ? "Sửa khách hàng" : "Sửa tài xế"
                            : isAddCustomer ? "Thêm khách hàng" : "Thêm tài xế"
                    },
                ])}
            </div>

            <div className='m-4 mt-16'>
                {isReady ? (
                    <div className={`bg-white rounded-lg`}
                        style={{
                            border: '1px solid #DBE3EF',
                            borderTop: '1px solid #DBE3EF',
                        }}>
                        < div className="row m-0 p-0 px-2 mt-4">
                            {/* avatar */}
                            <div className="col-12 mb-4 px-2">
                                {UIHelper.buildFormLabel('Ảnh đại diện')}
                                <div className="row m-0 p-0">
                                    <div className="col-lg-2 col-md-4 col-6 p-0 mb-2">
                                        <KTImageInput
                                            fullWidth={true}
                                            aspectRatio={'1'}
                                            name="avatar"
                                            editable={true}
                                            value={Utils.isValid(avatar) ? Utils.getFullUrl(avatar) : null}
                                            acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                            defaultImage={AppResource.icons.avatar.default}
                                            enableCheckValid
                                            onSelectedFile={(file) => {
                                                setAvatarFile(file);
                                                const imageUrl = URL.createObjectURL(file);
                                                setAvatar(imageUrl);
                                            }}
                                            onRemovedFile={() => {
                                                setAvatarFile(null);
                                                setAvatar('');
                                            }}
                                        />
                                    </div>
                                    <div className='p-0'>
                                        Định dạng: JPG, PNG, JPEG
                                    </div>
                                </div>
                            </div>
                            {/* type */}
                            <div className="col-12 mb-4 px-2">
                                <div className="radio-inline w-100 d-flex gap-4">
                                    <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                        {isAddCustomer ? 'Loại khách hàng' : 'Loại tài xế'}{' '}
                                        <span style={{
                                            ...UIHelper.buildFontStyle('700', '13px', AppColors.gray[800]),
                                            color: AppColors.danger
                                        }}>*</span>
                                    </span>
                                    <KTRadio
                                        name="Cá nhân"
                                        checked={type === FleetConstants.FleetDriverType.PERSONAL}
                                        label="Cá nhân"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            setType(FleetConstants.FleetDriverType.PERSONAL);
                                            setDriverPersonal(true);
                                        }}
                                        enableCheckValid
                                        disabled={driverDetail || !isAddCustomer}
                                    />
                                    <KTRadio
                                        name="Thuộc doanh nghiệp"
                                        checked={type === FleetConstants.FleetDriverType.ORGANIZATION}
                                        label="Thuộc doanh nghiệp"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            setType(FleetConstants.FleetDriverType.ORGANIZATION)
                                            setDriverPersonal(false);
                                        }}
                                        enableCheckValid
                                        disabled={driverDetail || !isAddCustomer}
                                    />
                                </div>
                            </div>

                            {/* selectedAgency */}
                            {!isDriverPersonal && (
                                <div className="col-md-12 mb-4 px-2">
                                    {UIHelper.buildFormLabel('Doanh nghiệp quản lý', true)}
                                    {dropdownAgencyEl}
                                </div>
                            )}

                            {/* fullname */}
                            <div className="col-md-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Họ và tên', true)}
                                <KTFormInput
                                    type={KTFormInputType.text}
                                    placeholder="Nhập họ và tên"
                                    name="fullname"
                                    value={fullname}
                                    onChange={(value) => {
                                        setFullname(value);
                                    }}
                                    enableCheckValid={readyToValidate}
                                    isValid={Utils.isValid(fullname)}
                                    isTouched={readyToValidate}
                                    feedbackText="Họ và tên không hợp lệ"
                                />
                            </div>
                            {/* email */}
                            <div className="col-md-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Email', true)}
                                <KTFormInput
                                    type={KTFormInputType.email}
                                    placeholder="Nhập email"
                                    name="email"
                                    value={email}
                                    onChange={(value) => {
                                        setEmail(value);
                                    }}
                                    enableCheckValid={readyToValidate}
                                    isValid={Utils.isValid(email) && email.match(AppConfigs.regex.email)}
                                    isTouched={readyToValidate}
                                    disabled={!!driverDetail}
                                    feedbackText="Email không hợp lệ"
                                />
                            </div>
                            {/* phone */}
                            <div className="col-md-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Số điện thoại', true)}
                                <KTFormInput
                                    type={KTFormInputType.telephone}
                                    placeholder="Nhập số điện thoại"
                                    name="phone"
                                    value={phone}
                                    onChange={(value) => {
                                        setPhone(value);
                                    }}
                                    enableCheckValid={readyToValidate}
                                    isValid={Utils.isValid(phone) && phone.match(AppConfigs.regex.phone)}
                                    isTouched={readyToValidate}
                                    feedbackText="Số điện thoại không hợp lệ"
                                />
                            </div>
                            {!isDriverPersonal && (
                                <>
                                    {/* companyCode */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Mã tài xế của doanh nghiêp', true)}
                                        <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập mã tài xế của doanh nghiệp"
                                            name="companyCode"
                                            value={companyCode}
                                            onChange={(value) => {
                                                setCompanyCode(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isValid={Utils.isValid(companyCode)}
                                            isTouched={readyToValidate}
                                            feedbackText="Mã tài xế không hợp lệ"
                                        />
                                    </div>
                                    {/* workingType */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Hình thức làm việc', true)}
                                        <KTBSDropdown
                                            toggleElement={({ showError }) => (
                                                <button
                                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                                    type="button"
                                                >
                                                    {workingType ? FleetHelper.Utils.getFleetDriverWorkingTypeName(workingType) : 'Chọn hình thức làm việc'}
                                                </button>
                                            )}
                                            selectedValue={workingType}
                                            dropdownMenuItems={FleetHelper.Data.workingTypeOptions}
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            dropdownMenuClassName="overflow-auto w-100"
                                            onChange={(value) => {
                                                setWorkingType(value);
                                            }}
                                            enableCheckValid
                                            isValid={Utils.isValid(workingType)}
                                            isTouched={readyToValidate}
                                            feedbackText="Hình thức làm việc không hợp lệ"
                                            isDropdownForm={true}
                                        />
                                    </div>
                                    {/* carNumbers */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Số lượng xe cho phép', true)}
                                        <KTFormInput
                                            type={KTFormInputType.currency}
                                            placeholder="Nhập số lượng xe cho phép"
                                            name="carNumbers"
                                            value={carNumbers}
                                            unit='Xe'
                                            onChange={(value) => {
                                                setCarNumbers(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isValid={Utils.isValid(carNumbers) && carNumbers >= 0}
                                            isTouched={readyToValidate}
                                            feedbackText="Số lượng xe không hợp lệ"
                                        />
                                    </div>
                                    <div className='col-12 px-2 mb-4'>
                                        <div style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}></div>
                                    </div>
                                    {/* paymentMethod */}
                                    <div className="col-md-12 mb-4 px-2">
                                        <div className="radio-inline w-100 d-flex gap-4">
                                            <div className='d-flex gap-2 align-items-center'>
                                                <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                                    Chính sách thanh toán phí sạc{' '}
                                                    <span style={{
                                                        ...UIHelper.buildFontStyle('700', '13px', AppColors.gray[800]),
                                                        color: AppColors.danger
                                                    }}>*</span>
                                                </span>
                                            </div>
                                            <KTRadio
                                                name="Doanh nghiệp thanh toán"
                                                checked={paymentMethod === FleetConstants.PaymentMethod.FLEET}
                                                label="Doanh nghiệp thanh toán"
                                                type={KTRadioType.outline}
                                                additionalClassName="radio-success"
                                                onChange={() => {
                                                    setPaymentMethod(FleetConstants.PaymentMethod.FLEET);
                                                }}
                                                enableCheckValid
                                            />
                                            <KTRadio
                                                name="Tài xế thanh toán"
                                                checked={paymentMethod === FleetConstants.PaymentMethod.WALLET}
                                                label="Tài xế thanh toán"
                                                type={KTRadioType.outline}
                                                additionalClassName="radio-success"
                                                onChange={() => {
                                                    setPaymentMethod(FleetConstants.PaymentMethod.WALLET)
                                                }}
                                                enableCheckValid
                                            />
                                        </div>
                                    </div>
                                    {/* creditLimitPeriod */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Kỳ hạn áp dụng')}
                                        <KTBSDropdown
                                            toggleElement={({ showError }) => (
                                                <button
                                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                                    type="button"
                                                >
                                                    {creditLimitPeriod ? FleetHelper.Utils.getCreditLimitPeriodName(creditLimitPeriod) : 'Chọn kỳ hạn áp dụng'}
                                                </button>
                                            )}
                                            selectedValue={creditLimitPeriod}
                                            dropdownMenuItems={FleetHelper.Data.creditLimitPeriodOptions}
                                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                                            dropdownMenuClassName="overflow-auto w-100"
                                            onChange={(value) => {
                                                setCreditLimitPeriod(value);
                                            }}
                                            enableCheckValid
                                            // isValid={Utils.isValid(creditLimitPeriod)}
                                            isTouched={readyToValidate}
                                            feedbackText="Kỳ hạn áp dụng không hợp lệ"
                                            isDropdownForm={true}
                                        />
                                    </div>
                                    {/* creditLimit */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Hạn mức')}
                                        <KTFormInput
                                            type={KTFormInputType.currency}
                                            placeholder="Nhập hạn mức"
                                            name="creditLimit"
                                            value={creditLimit}
                                            onChange={(value) => {
                                                setCreditLimit(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isValid={!Utils.isValid(creditLimit) || Utils.isValid(creditLimit) && creditLimit >= 0}
                                            isTouched={readyToValidate}
                                            feedbackText="Hạn mức không hợp lệ"
                                        />
                                    </div>
                                </>
                            )}
                            <div className='col-12 px-2 mb-4'>
                                <div style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}></div>
                            </div>
                            {/* discountType */}
                            <div className="col-md-12 mb-4 px-2">
                                <div className="radio-inline w-100 d-flex gap-4">
                                    <div className='d-flex gap-2 align-items-center'>
                                        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                            Loại giá sạc{' '}
                                            <span style={{
                                                ...UIHelper.buildFontStyle('700', '13px', AppColors.gray[800]),
                                                color: AppColors.danger
                                            }}>*</span>
                                        </span>
                                        <KTTooltip
                                            text={`<div>Giá sạc được áp dụng cho khách hàng mỗi lần sạc xe.</div>`}
                                            textHeader="Loại giá sạc"
                                            isHtmlContent
                                        >
                                            <i
                                                className="fa-regular fa-info-circle"
                                                style={{ color: AppColors.info }}
                                            />
                                        </KTTooltip>
                                    </div>
                                    <KTRadio
                                        name="Tiêu chuẩn"
                                        checked={discountType === FleetConstants.PricingType.STANDARD}
                                        label="Tiêu chuẩn"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            setDiscountType(FleetConstants.PricingType.STANDARD);
                                        }}
                                        enableCheckValid
                                    // disabled={driverDetail}
                                    />
                                    <KTRadio
                                        name="Ưu đãi"
                                        checked={discountType === FleetConstants.PricingType.DISCOUNT}
                                        label="Ưu đãi"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            setDiscountType(FleetConstants.PricingType.DISCOUNT)
                                        }}
                                        enableCheckValid
                                    // disabled={driverDetail}
                                    />
                                    <KTRadio
                                        name="Miễn phí"
                                        checked={discountType === FleetConstants.PricingType.FREE}
                                        label="Miễn phí"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            setDiscountType(FleetConstants.PricingType.FREE)
                                        }}
                                        enableCheckValid
                                    // disabled={driverDetail}
                                    />
                                </div>
                            </div>
                            {/* discountRate */}
                            {discountType === FleetConstants.PricingType.DISCOUNT && (
                                <div className="col-md-4 mb-4 px-2">
                                    {UIHelper.buildFormLabel('Tỷ lệ chiết khấu', true)}
                                    <KTFormInput
                                        type={KTFormInputType.number}
                                        placeholder="Nhập tỷ lệ chiết khấu"
                                        name="discountRate"
                                        value={discountRate}
                                        unit='%'
                                        onChange={(value) => {
                                            setDiscountRate(value);
                                        }}
                                        enableCheckValid={readyToValidate}
                                        isValid={
                                            discountRate > 0 && discountRate < 100
                                        }
                                        checkValidInput={(value) => {
                                            return value === '' || /^\d+(\.\d{0,1})?$/.test(value)
                                        }}
                                        isTouched={readyToValidate}
                                        feedbackText={discountType === 'DISCOUNT'
                                            ? discountRate <= 0
                                                ? 'Tỷ lệ chiết khấu phải lớn hơn 0%'
                                                : discountRate >= 100
                                                    ? 'Tỷ lệ chiết khấu phải nhỏ hơn 100%'
                                                    : ''
                                            : ''}
                                    />
                                </div>
                            )}
                            {isDriverPersonal && (
                                <>
                                    <div className='col-12 px-2 mb-4'>
                                        <div style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}></div>
                                    </div>
                                    <div className='pl-2 mb-4' style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                        Thông tin xuất hóa đơn công ty
                                    </div>
                                    {/* companyName */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Tên công ty')}
                                        <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập tên công ty/doanh nghiệp"
                                            name="companyName"
                                            value={companyName}
                                            onChange={(value) => {
                                                setCompanyName(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isTouched={readyToValidate}
                                        />
                                    </div>
                                    {/* taxCode */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('MST/Mã số định danh')}
                                        <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập MST/Mã số định danh"
                                            name="taxCode"
                                            value={taxCode}
                                            onChange={(value) => {
                                                setTaxCode(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isValid={!Utils.isValid(taxCode) || Utils.isValid(taxCode) &&
                                                (taxCode.match(AppConfigs.regex.taxCode10) || taxCode.match(AppConfigs.regex.taxCode13))}
                                            isTouched={readyToValidate}
                                            feedbackText="MST/Mã số định danh không hợp lệ"
                                        />
                                    </div>
                                    {/* address */}
                                    <div className="col-md-4 mb-4 px-2">
                                        {UIHelper.buildFormLabel('Địa chỉ')}
                                        <KTFormInput
                                            type={KTFormInputType.text}
                                            placeholder="Nhập địa chỉ công ty/doanh nghiệp"
                                            name="address"
                                            value={address}
                                            onChange={(value) => {
                                                setAddress(value);
                                            }}
                                            enableCheckValid={readyToValidate}
                                            isTouched={readyToValidate}
                                        />
                                    </div>
                                </>
                            )}
                            <div className='col-12 px-2 mb-4'>
                                <div style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}></div>
                            </div>
                            <div className='pl-2 mb-4' style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                                Thông tin CCCD
                            </div>
                            {/* idCardNumber */}
                            <div className="col-md-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Số CCCD')}
                                <KTFormInput
                                    type={KTFormInputType.text}
                                    placeholder="Nhập số CCCD"
                                    name="idCardNumber"
                                    value={idCardNumber}
                                    onChange={(value) => {
                                        setIdCardNumber(value);
                                    }}
                                    enableCheckValid={readyToValidate}
                                    isValid={!Utils.isValid(idCardNumber) || Utils.isValid(idCardNumber) && idCardNumber.match(AppConfigs.regex.idCardNumber)}
                                    isTouched={readyToValidate}
                                    feedbackText="Số CCCD không hợp lệ"
                                />
                            </div>
                            {UIHelper.buildFormLabel('Tải lên căn cước công dân')}
                            <div className='col-4 mb-4 px-2'>
                                <KTImageInput
                                    fullWidth={true}
                                    aspectRatio={'14/9'}
                                    name={`idCardDocuments[0]`}
                                    value={idCardDocuments?.[0] ? Utils.getFullUrl(idCardDocuments[0]) : null}
                                    acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                    defaultImage={AppResource.images.evg.frontIdCard}
                                    editable={true}
                                    onSelectedFile={(file) => {
                                        handleSetImage(file, 0);
                                        const image = URL.createObjectURL(file);
                                        setIdCardDocuments(prev => {
                                            const newDocs = [...(prev || [])];
                                            newDocs[0] = image;
                                            return newDocs;
                                        });
                                    }}
                                    onRemovedFile={() => {
                                        handleSetImage(null, 0);
                                        setIdCardDocuments(prev => {
                                            const newDocs = [...(prev || [])];
                                            newDocs[0] = null;
                                            return newDocs;
                                        });
                                    }}
                                    additionalInputClassName="h-100"
                                    backgroundSize="contain"
                                    isUploadIdCard={true}
                                    uploadContent="Mặt trước"
                                    enableCheckValid={readyToValidate}
                                    // isValid={!!imageSrc?.[0]}
                                    isTouched={readyToValidate}
                                    feedbackText="Vui lòng tải lên CCCD"
                                />
                            </div>
                            <div className='col-4 mb-4 px-2'>
                                <KTImageInput
                                    fullWidth={true}
                                    aspectRatio={'14/9'}
                                    name={`idCardDocuments[1]`}
                                    value={idCardDocuments?.[1] ? Utils.getFullUrl(idCardDocuments[1]) : null}
                                    acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                    defaultImage={AppResource.images.evg.frontIdCard}
                                    editable={true}
                                    onSelectedFile={(file) => {
                                        handleSetImage(file, 1);
                                        const image = URL.createObjectURL(file);
                                        setIdCardDocuments(prev => {
                                            const newDocs = [...(prev || [])];
                                            newDocs[1] = image;
                                            return newDocs;
                                        });
                                    }}
                                    onRemovedFile={() => {
                                        handleSetImage(null, 1);
                                        setIdCardDocuments(prev => {
                                            const newDocs = [...(prev || [])];
                                            newDocs[1] = null;
                                            return newDocs;
                                        });
                                    }}
                                    additionalInputClassName="h-100"
                                    backgroundSize="contain"
                                    isUploadIdCard={true}
                                    uploadContent="Mặt sau"
                                    enableCheckValid={readyToValidate}
                                    // isValid={!!imageSrc?.[1]}
                                    isTouched={readyToValidate}
                                    feedbackText="Vui lòng tải lên CCCD"
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>Loading...</div>
                )}
            </div>

            <footer className="w-100 position-fixed bottom-0 end-0 bg-white py-3 shadow-sm">
                <div className="container-fluid px-4">
                    <div className="d-flex justify-content-end gap-2">
                        <Button
                            variant="secondary"
                            className="fw-bold"
                            style={{
                                fontSize: '13px',
                                color: AppColors.gray[800],
                                padding: '8px 16px',
                            }}
                            onClick={handleClose}
                        >
                            Hủy bỏ
                        </Button>

                        <Button
                            variant="success"
                            className="fw-bold"
                            style={{
                                fontSize: '14px',
                                padding: '8px 16px',
                            }}
                            onClick={handleSubmit}
                        >
                            {driverDetail ? 'Lưu lại' : 'Tạo mới'}
                        </Button>
                    </div>
                </div>
            </footer>
        </div >
    );
}

export default EditDriverView;
